import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TopHeader from "../../Components/TopHeader";
import { toast, ToastContainer } from "react-toastify";
import MainHeader from "../../Components/MainHeader";
import Footer from "../../Components/Footer";
import "./single.css";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { addContactDetails, addReviewDetails } from "../../firebase";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import AlertDialog from "../../Components/AlertDialog";
import AddToCartButton from "../../Components/AddToCartButton/AddToCartButton";

const ProductSingle = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedCars = [] } = location.state || {}; // Default to empty array

  const [cartItems, setCartItems] = useState(selectedCars);

  const [mainMedia, setMainMedia] = useState(
    selectedCars.length > 0
      ? selectedCars[0]?.images?.[0] || selectedCars[0]?.videos?.[0] || ""
      : ""
  );
  const [isVideo, setIsVideo] = useState(
    selectedCars.length > 0 ? selectedCars[0]?.videos?.length > 0 : false
  );

  // Enhanced cart item structure with all checkout fields
  const [enhancedCartItems, setEnhancedCartItems] = useState([]);

  // Fixed calculateTotals function with proper error handling
  const calculateTotals = () => {
    if (!cartItems || cartItems.length === 0 || !cartItems[0]?.activePlan) {
      return { totalPrice: 0, discount: 50, total: 0 };
    }
    
    try {
      const totalPrice = parseInt(
        cartItems[0].activePlan.price.toString().replace(/[^\d]/g, "") || "0"
      );
      const discount = 50;
      const total = Math.max(0, totalPrice - discount); // Ensure total doesn't go negative
      
      return { totalPrice, discount, total };
    } catch (error) {
      console.error("Error calculating totals:", error);
      return { totalPrice: 0, discount: 50, total: 0 };
    }
  };

  useEffect(() => {
    if (selectedCars.length > 0) {
      const firstCar = selectedCars[0];
      setMainMedia(firstCar?.images?.[0] || firstCar?.videos?.[0] || "");
      setIsVideo(firstCar?.videos?.length > 0 && !firstCar?.images?.length);
      
      // Initialize enhanced cart items with all required checkout fields
      const enhanced = selectedCars.map(car => ({
        ...car,
        // Ensure core fields exist
        id: car.id || Date.now().toString(),
        headTitle: car.headTitle || car.modelName || "Motor Service",
        productDescription: car.productDescription || "Professional motor service",
        productCode: car.productCode || `MS-${Math.random().toString(36).substr(2, 9).toUpperCase()}`,
        
        // Service information
        serviceType: car.serviceType || "Standard Service",
        carType: car.carType || "Car", 
        engineCapacity: car.engineCapacity || "1.0L - 3.0L",
        
        // User billing information
        name: "",
        email: "",
        address: "",
        address2: "",
        country: "",
        state: "",
        zip: "",
        phoneNumber: "",
        
        // Vehicle information (some may come from existing car data)
        carNumber: car.carNumber || "",
        model: car.modelName || "",
        make: car.make || "",
        regDate: car.firstRegistrationDate || "",
        motExpDate: car.motExpiryDate || "",
        
        // Additional vehicle fields
        currentKm: "",
        vinNumber: "",
        vehicleAccident: "",
        
        // Service booking information
        bookingDate: car.bookingDate || "",
        postcode: car.postcode || "",
        
        // Customer information
        fname: car.fname || "",
        lname: car.lname || "",
        phone: car.phone || "",
        
        // Media
        images: car.images || [],
        videos: car.videos || [],
        
        // Pricing - ensure this exists
        prices: car.prices || [],
        activePlan: car.activePlan || null
      }));
      
      setEnhancedCartItems(enhanced);
    }
  }, [selectedCars]);

  const handleMediaClick = (src, isVideo) => {
    setMainMedia(src);
    setIsVideo(isVideo);
  };

  const handleSelectPlan = (modelId, selectedPlanId) => {
    const updatedItems = cartItems.map((item) => {
      if (item.id === modelId) {
        const selectedPlan = item.prices.find(
          (plan) => plan.id.toString() === selectedPlanId
        );
        return { ...item, activePlan: selectedPlan };
      }
      return item;
    });
    setCartItems(updatedItems);
    
    // Also update enhanced cart items
    const updatedEnhancedItems = enhancedCartItems.map((item) => {
      if (item.id === modelId) {
        const selectedPlan = item.prices.find(
          (plan) => plan.id.toString() === selectedPlanId
        );
        return { ...item, activePlan: selectedPlan };
      }
      return item;
    });
    setEnhancedCartItems(updatedEnhancedItems);
    
    // Show alert when plan is selected
    const selectedPlan = updatedItems.find(item => item.id === modelId)?.activePlan;
    if (selectedPlan) {
      AlertDialog(
        "Plan Selected",
        `${selectedPlan.plan_name} - ${selectedPlan.plan_duration} plan selected`,
        "success",
        1200,
        false,
        false,
        "",
        "",
        null,
        null
      );
    }
  };

  // Function to update cart item fields
  const updateCartItemField = (itemId, field, value) => {
    setEnhancedCartItems(prevItems => 
      prevItems.map(item => 
        item.id === itemId 
          ? { ...item, [field]: value }
          : item
      )
    );
  };

  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    message: "",
    phone: "",
    postcode: "",
    regNo: ""
  });

  const [reviewForm, setReviewForm] = useState({
    UserName: "",
    Comment: "",
  });

  const [loading, setLoading] = useState(false);
  const [reviewLoading, setReviewLoading] = useState(false);

  const [formStatus, setFormStatus] = useState("");
  const [reviewformStatus, setReviewFormStatus] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "UserName" || name === "Comment") {
      setReviewForm((prevForm) => ({
        ...prevForm,
        [name]: value,
      }));
    } else {
      setContactForm((prevForm) => ({
        ...prevForm,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      
      // Update the enhanced cart item with contact form data
      if (enhancedCartItems.length > 0) {
        const updatedItems = enhancedCartItems.map(item => ({
          ...item,
          name: contactForm.name,
          email: contactForm.email,
          phoneNumber: contactForm.phone,
          zip: contactForm.postcode,
          carNumber: contactForm.regNo,
          fname: contactForm.name.split(' ')[0] || contactForm.name,
          lname: contactForm.name.split(' ').slice(1).join(' ') || ""
        }));
        
        setEnhancedCartItems(updatedItems);
      }
      
      await addContactDetails(contactForm);
      
      // Show success alert for contact form submission
      AlertDialog(
        "Information Updated",
        "Your contact details have been saved and will be used for checkout.",
        "success",
        2000,
        false,
        false,
        "",
        "",
        null,
        null
      );
      
      setFormStatus("Thanks for contacting us.");
      
      // Don't reset form immediately - keep the data for checkout
      // setContactForm({ 
      //   name: "", 
      //   email: "", 
      //   message: "",
      //   phone: "",
      //   postcode: "",
      //   regNo: ""
      // });
    } catch (error) {
      // Show error alert
      AlertDialog(
        "Error",
        "Failed to save your information. Please try again.",
        "error",
        2000,
        false,
        false,
        "",
        "",
        null,
        null
      );
      setFormStatus("Error saving information. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleReviewSubmit = async (e) => {
    e.preventDefault();
    try {
      setReviewLoading(true);
      await addReviewDetails(reviewForm);
      
      // Show success alert for review submission
      AlertDialog(
        "Comment Added",
        "Thank you for your feedback!",
        "success",
        1500,
        false,
        false,
        "",
        "",
        null,
        null
      );
      
      setReviewFormStatus("Thanks for commenting.");
      setReviewForm({ UserName: "", Comment: "" }); // Reset form
    } catch (error) {
      // Show error alert
      AlertDialog(
        "Error",
        "Failed to add your comment. Please try again.",
        "error",
        1500,
        false,
        false,
        "",
        "",
        null,
        null
      );
      setReviewFormStatus("Error adding comment. Please try again.");
    } finally {
      setReviewLoading(false);
    }
  };

  const handleCheckout = () => {
  if (!cartItems || cartItems.length === 0 || !cartItems[0]?.activePlan) {
    AlertDialog(
      "Selection Required",
      "Please select a plan before proceeding to checkout",
      "warning",
      1500,
      false,
      false,
      "",
      "",
      null,
      null
    );
    return;
  }
  
  AlertDialog(
    "Proceeding to Checkout",
    "Taking you to the payment page",
    "success",
    800,
    false,
    false,
    "",
    "",
    null,
    null
  );
  
  setTimeout(() => {
    const { totalPrice, discount, total } = calculateTotals();
    
    // SAFE NAVIGATION - ensure all data is serializable
    const safeCartItems = enhancedCartItems.map(item => ({
      ...item,
      id: String(item.id || Date.now()),
      activePlan: item.activePlan ? {
        ...item.activePlan,
        id: String(item.activePlan.id),
        price: String(item.activePlan.price)
      } : null
    }));
    
    navigate("/checkout", {
      state: {
        cartItems: safeCartItems,
        discount: Number(discount) || 0,
        totalPrice: Number(totalPrice) || 0,
        total: Number(total) || 0,
      },
    });
  }, 1000);
};
  return (
    <>
      <TopHeader />
      <MainHeader />
      <ToastContainer />
      <section className="py-5" style={{ translate: "0 -40px" }}>
        <div className="container">
          <div className="row gx-5">
            <aside className="col-lg-6">
              <div className="border rounded-4 mb-3 d-flex justify-content-center overflow-hidden">
                <a
                  data-fslightbox="mygalley"
                  className="rounded-4"
                  data-type="image"
                  href={`https://motor-easy.clickbooster.io/assets/entryimages/${mainMedia.image}`}
                >
                  {isVideo ? (
                    <video
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100vh",
                        margin: "auto",
                      }}
                      className="rounded-4 fit main_image_single"
                      src={`https://motor-easy.clickbooster.io/assets/entryvideos/${mainMedia.video}`}
                      controls
                      alt="Product Video"
                    />
                  ) : (
                    <img
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100vh",
                        margin: "auto",
                      }}
                      className="rounded-4 fit main_image_single"
                      src={`https://motor-easy.clickbooster.io/assets/entryimages/${mainMedia.image}`}
                      alt="Product"
                    />
                  )}
                </a>
              </div>
              <div className="d-flex justify-content-start mb-3">
                {cartItems[0]?.images?.map((img, index) => (
                  <a
                    key={`img-${index}`}
                    data-fslightbox="mygalley"
                    className="border mx-1 rounded-2"
                    target="_blank"
                    data-type="image"
                    href={`https://motor-easy.clickbooster.io/assets/entryimages/${img.image}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleMediaClick(img, false);
                    }}
                    rel="noreferrer"
                  >
                    <img
                      width={70}
                      height={70}
                      className="rounded-2"
                      src={`https://motor-easy.clickbooster.io/assets/entryimages/${img.image}`}
                      alt={`Thumbnail ${index + 1}`}
                    />
                  </a>
                ))}
                {cartItems[0]?.videos?.map((vid, index) => (
                  <a
                    key={`vid-${index}`}
                    data-fslightbox="mygalley"
                    className="border mx-1 rounded-2"
                    target="_blank"
                    data-type="video"
                    href={`https://motor-easy.clickbooster.io/assets/entryvideos/${vid.video}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleMediaClick(vid, true);
                    }}
                    rel="noreferrer"
                  >
                    <video
                      width={70}
                      height={70}
                      className="rounded-2"
                      src={`https://motor-easy.clickbooster.io/assets/entryvideos/${vid.video}`}
                      alt={`Video Thumbnail ${index + 1}`}
                    />
                  </a>
                ))}
              </div>
            </aside>
            <main className="col-lg-6">
              {cartItems.map((item) => (
                <div className="ps-lg-3" key={item.id}>
                  <h4 className="title text-dark">
                    {item.modelName
                      ? item.modelName
                      : "Model Name Not Available"}
                  </h4>
                  <p className="text-secondary">
                    {item.headTitle || "Title Not Available"}
                  </p>
                  <p>
                    {item.productDescription || "Description Not Available"}
                  </p>
                  <div className="row">
                    <div className="container">
                      <div className="row">
                        <dt className="col-3">Type:</dt>
                        <dd className="col-9">{item.carType || "Car"}</dd>
                        <dt className="col-3">Engine Capacity:</dt>
                        <dd className="col-9">
                          {item.engineCapacity || "1.0L - 3.0L"}
                        </dd>
                        <dt className="col-3">Service Type:</dt>
                        <dd className="col-9">{item.serviceType || "Standard Service"}</dd>
                        <dt className="col-3">Model Name:</dt>
                        <dd className="col-9">
                          {item.modelName || "Professional Service"}
                        </dd>
                        <dt className="col-3">Product Code:</dt>
                        <dd className="col-9">
                          {item.productCode || "MS-SERVICE001"}
                        </dd>
                        <dt className="col-3">From Price:</dt>
                        <dd className="col-9">
                          {!item.activePlan
                            ? "Select the plan first"
                            : `${item.activePlan.plan_name || "Plan Name"} - ${item.activePlan.plan_duration || "Duration"
                            } - $${item.activePlan.price || "Price"}`
                          }
                        </dd>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex flex-column flex-md-row align-items-center gap-3">
                    <DropdownButton
                      id={`dropdown-${item.id}`}
                      title={
                        item.activePlan
                          ? `${item.activePlan.plan_name || "Plan Name"} - ${item.activePlan.plan_duration || "Duration"} - $${item.activePlan.price || "Price"}`
                          : "Select plan"
                      }
                      onSelect={(selectedPlanId) => {
                        handleSelectPlan(item.id, selectedPlanId);
                      }}
                      style={{ zIndex: 1000 }}
                    >
                      {item.prices && item.prices.length > 0 ? (
                        item.prices.map((plan, index) => (
                          <Dropdown.Item key={`${plan.id}-${index}`} eventKey={plan.id.toString()}>
                            {`${plan.plan_name || "Plan Name"} - ${plan.plan_duration || "Duration"} - $${plan.price || "Price"}`}
                          </Dropdown.Item>
                        ))
                      ) : (
                        <Dropdown.Item disabled>No plans available</Dropdown.Item>
                      )}
                    </DropdownButton>

                    {/* Show "Buy Now" button only when a plan is selected */}
                    {item.activePlan && (
                     <div className="d-flex gap-2">
                      {/* Import AddToCartButton at the top of the file */}
                      <AddToCartButton product={item} selectedPlan={item.activePlan} />
                      
                      <button onClick={handleCheckout} className="btn btn-primary shadow-0">
                        <i className="me-1 fa fa-shopping-basket" /> Buy Now
                      </button>
                    </div>
                    )}
                  </div>
                </div>
              ))}
            </main>
          </div>
        </div>
      </section>

      <section className="bg-light border-top py-4">
        <div className="container">
          <div className="row gx-4">
            <div className="col-lg-8 mb-4">
              <div className="border rounded-2 px-3 py-2 bg-white">
                <div className="tab-content" id="ex1-content">
                  <h2 className="text-center fw-bold">Description</h2>
                  {cartItems.map((item, index) => (
                    <div
                      key={item.id || `cart-item-${index}`} // Ensure unique key
                      className={`tab-pane fade ${index === 0 ? "show active" : ""
                        }`} // Set active for first item
                      id={`ex1-pills-${item.id}`} // Unique ID pattern
                      role="tabpanel"
                      aria-labelledby={`ex1-tab-${item.id}`}
                    >
                      {/* Display d_title (Fixed Property Name) */}
                      <h3 className="fw-bold">
                        {item.title || item.headTitle || "Professional Motor Service"}
                      </h3>

                      {/* Display d_feature as Bullet Points (Fixed Property Name & Validation) */}
                      <div className="row mb-2">
                        <div className="col-12">
                          <ul className="list-unstyled">
                            {typeof item.feature === "string" &&
                              item.feature.trim() ? (
                              item.feature.split(",").map((feature, idx) => (
                                <li key={idx}>
                                  <i className="fas fa-check text-success me-2" />
                                  {feature.trim()}
                                </li>
                              ))
                            ) : (
                              // Default features if none provided
                              <>
                                <li><i className="fas fa-check text-success me-2" />Professional motor service</li>
                                <li><i className="fas fa-check text-success me-2" />Expert technicians</li>
                                <li><i className="fas fa-check text-success me-2" />Quality guarantee</li>
                                <li><i className="fas fa-check text-success me-2" />Competitive pricing</li>
                              </>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-12 col-md-12 my-5">
                <h2>Leave a comment </h2>
                <form onSubmit={handleReviewSubmit}>
                  <div className="mb-3">
                    <label htmlFor="UserName" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      id="UserName"
                      name="UserName"
                      className="form-control"
                      value={reviewForm.UserName}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="Comment" className="form-label">
                      Comment
                    </label>
                    <textarea
                      id="Comment"
                      name="Comment"
                      className="form-control"
                      rows="3"
                      value={reviewForm.Comment}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  {reviewformStatus && (
                    <p className="mt-2 text-success fw-bold">
                      {reviewformStatus}
                    </p>
                  )}
                  <button
                    type="submit"
                    className="btn btn-dark"
                    disabled={reviewLoading}
                  >
                    Comment
                  </button>
                </form>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="px-0 border rounded-2 shadow-0">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">Contact Us & Vehicle Details</h5>
                    <p className="small text-muted">Fill out this form to pre-populate your checkout information</p>
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                          Name *
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          value={contactForm.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label htmlFor="email" className="form-label">
                          Email *
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          value={contactForm.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label htmlFor="phone" className="form-label">
                          Phone Number *
                        </label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          className="form-control"
                          placeholder="Phone number (with country code)"
                          value={contactForm.phone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label htmlFor="postcode" className="form-label">
                          Post Code *
                        </label>
                        <input
                          type="text"
                          id="postcode"
                          name="postcode"
                          className="form-control"
                          value={contactForm.postcode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label htmlFor="regNo" className="form-label">
                          Vehicle Registration Number *
                        </label>
                        <input
                          type="text"
                          id="regNo"
                          name="regNo"
                          className="form-control"
                          placeholder="e.g., AB12 CDE"
                          value={contactForm.regNo}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label htmlFor="message" className="form-label">
                          Additional Notes
                        </label>
                        <textarea
                          id="message"
                          name="message"
                          className="form-control"
                          rows="3"
                          value={contactForm.message}
                          onChange={handleInputChange}
                          placeholder="Any special requirements or notes..."
                        />
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save Information"}
                      </button>
                    </form>

                    {formStatus && (
                      <p className="mt-2 text-success fw-bold">{formStatus}</p>
                    )}
                    
                    <div className="mt-3 p-2 bg-light rounded">
                      <small className="text-muted">
                        <i className="fas fa-info-circle me-1"></i>
                        This information will be used to pre-fill your checkout form and contact you about your service.
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ProductSingle;